module.exports = {
  getSplit5AgeList: function(myMap) {
    myMap.set('769',[1,1,1,1,1,1,1,1,1,1]);
    myMap.set('759',[1,1,1,1,1,1,1,1,1,0]);
    myMap.set('749',[1,1,1,1,1,1,1,1,0,0]);
    myMap.set('744',[1,1,1,1,1,1,1,0,0,0]);
    myMap.set('739',[1,1,1,1,1,1,0,0,0,0]);
    myMap.set('734',[1,1,1,1,1,0,0,0,0,0]);
    myMap.set('729',[1,1,1,1,0,0,0,0,0,0]);
    myMap.set('724',[1,1,1,0,0,0,0,0,0,0]);
    myMap.set('718',[1,1,0,0,0,0,0,0,0,0]);
    myMap.set('712',[1,0,0,0,0,0,0,0,0,0]);
    myMap.set('6069',[0,0,0,0,0,0,0,0,0,1]);
    myMap.set('5069',[0,0,0,0,0,0,0,0,1,1]);
    myMap.set('5059',[0,0,0,0,0,0,0,0,1,0]);
    myMap.set('4569',[0,0,0,0,0,0,0,1,1,1]);
    myMap.set('4559',[0,0,0,0,0,0,0,1,1,0]);
    myMap.set('4549',[0,0,0,0,0,0,0,1,0,0]);
    myMap.set('4069',[0,0,0,0,0,0,1,1,1,1]);
    myMap.set('4059',[0,0,0,0,0,0,1,1,1,0]);
    myMap.set('4049',[0,0,0,0,0,0,1,1,0,0]);
    myMap.set('4044',[0,0,0,0,0,0,1,0,0,0]);
    myMap.set('3569',[0,0,0,0,0,1,1,1,1,1]);
    myMap.set('3559',[0,0,0,0,0,1,1,1,1,0]);
    myMap.set('3549',[0,0,0,0,0,1,1,1,0,0]);
    myMap.set('3544',[0,0,0,0,0,1,1,0,0,0]);
    myMap.set('3539',[0,0,0,0,0,1,0,0,0,0]);
    myMap.set('3069',[0,0,0,0,1,1,1,1,1,1]);
    myMap.set('3059',[0,0,0,0,1,1,1,1,1,0]);
    myMap.set('3049',[0,0,0,0,1,1,1,1,0,0]);
    myMap.set('3044',[0,0,0,0,1,1,1,0,0,0]);
    myMap.set('3039',[0,0,0,0,1,1,0,0,0,0]);
    myMap.set('3034',[0,0,0,0,1,0,0,0,0,0]);
    myMap.set('2569',[0,0,0,1,1,1,1,1,1,1]);
    myMap.set('2559',[0,0,0,1,1,1,1,1,1,0]);
    myMap.set('2549',[0,0,0,1,1,1,1,1,0,0]);
    myMap.set('2544',[0,0,0,1,1,1,1,0,0,0]);
    myMap.set('2539',[0,0,0,1,1,1,0,0,0,0]);
    myMap.set('2534',[0,0,0,1,1,0,0,0,0,0]);
    myMap.set('2529',[0,0,0,1,0,0,0,0,0,0]);
    myMap.set('1969',[0,0,1,1,1,1,1,1,1,1]);
    myMap.set('1959',[0,0,1,1,1,1,1,1,1,0]);
    myMap.set('1949',[0,0,1,1,1,1,1,1,0,0]);
    myMap.set('1944',[0,0,1,1,1,1,1,0,0,0]);
    myMap.set('1939',[0,0,1,1,1,1,0,0,0,0]);
    myMap.set('1934',[0,0,1,1,1,0,0,0,0,0]);
    myMap.set('1929',[0,0,1,1,0,0,0,0,0,0]);
    myMap.set('1924',[0,0,1,0,0,0,0,0,0,0]);
    myMap.set('1369',[0,1,1,1,1,1,1,1,1,1]);
    myMap.set('1359',[0,1,1,1,1,1,1,1,1,0]);
    myMap.set('1349',[0,1,1,1,1,1,1,1,0,0]);
    myMap.set('1344',[0,1,1,1,1,1,1,0,0,0]);
    myMap.set('1339',[0,1,1,1,1,1,0,0,0,0]);
    myMap.set('1334',[0,1,1,1,1,0,0,0,0,0]);
    myMap.set('1329',[0,1,1,1,0,0,0,0,0,0]);
    myMap.set('1324',[0,1,1,0,0,0,0,0,0,0]);
    myMap.set('1318',[0,1,0,0,0,0,0,0,0,0]);
  },
  getTargetPortionList: function(myMap) {
    myMap.set('Facebook_F', [
      {ageIndex:1, keyName:'Facebook_F', gender:'F', min:'7', max:'12', portion:0.0000000000},
      {ageIndex:2, keyName:'Facebook_F', gender:'F', min:'13', max:'18', portion:0.1044296509},
      {ageIndex:3, keyName:'Facebook_F', gender:'F', min:'19', max:'24', portion:0.1395557586},
      {ageIndex:4, keyName:'Facebook_F', gender:'F', min:'25', max:'29', portion:0.0789668959},
      {ageIndex:5, keyName:'Facebook_F', gender:'F', min:'30', max:'34', portion:0.0789668959},
      {ageIndex:6, keyName:'Facebook_F', gender:'F', min:'35', max:'39', portion:0.0337418640},
      {ageIndex:7, keyName:'Facebook_F', gender:'F', min:'40', max:'44', portion:0.0337418640},
      {ageIndex:8, keyName:'Facebook_F', gender:'F', min:'45', max:'49', portion:0.0143291987},
      {ageIndex:9, keyName:'Facebook_F', gender:'F', min:'50', max:'59', portion:0.0201669448},
      {ageIndex:10, keyName:'Facebook_F', gender:'F', min:'60', max:'69', portion:0.0119492596},
    ]);
    myMap.set('Facebook_M', [
      {ageIndex:1, keyName:'Facebook_M', gender:'M', min:'7', max:'12', portion:0.0000000000},
      {ageIndex:2, keyName:'Facebook_M', gender:'M', min:'13', max:'18', portion:0.0956695510},
      {ageIndex:3, keyName:'Facebook_M', gender:'M', min:'19', max:'24', portion:0.1609077490},
      {ageIndex:4, keyName:'Facebook_M', gender:'M', min:'25', max:'29', portion:0.0645452455},
      {ageIndex:5, keyName:'Facebook_M', gender:'M', min:'30', max:'34', portion:0.0645452455},
      {ageIndex:6, keyName:'Facebook_M', gender:'M', min:'35', max:'39', portion:0.0261773769},
      {ageIndex:7, keyName:'Facebook_M', gender:'M', min:'40', max:'44', portion:0.0261773769},
      {ageIndex:8, keyName:'Facebook_M', gender:'M', min:'45', max:'49', portion:0.0129971077},
      {ageIndex:9, keyName:'Facebook_M', gender:'M', min:'50', max:'59', portion:0.0170818657},
      {ageIndex:10, keyName:'Facebook_M', gender:'M', min:'60', max:'69', portion:0.0070116969},
    ]);
    myMap.set('Facebook_MF', [
      {ageIndex:1, keyName:'Facebook_MF', gender:'MF', min:'7', max:'12', portion:0.0000000000},
      {ageIndex:2, keyName:'Facebook_MF', gender:'MF', min:'13', max:'18', portion:0.2000992020},
      {ageIndex:3, keyName:'Facebook_MF', gender:'MF', min:'19', max:'24', portion:0.3004635076},
      {ageIndex:4, keyName:'Facebook_MF', gender:'MF', min:'25', max:'29', portion:0.1435121414},
      {ageIndex:5, keyName:'Facebook_MF', gender:'MF', min:'30', max:'34', portion:0.1435121414},
      {ageIndex:6, keyName:'Facebook_MF', gender:'MF', min:'35', max:'39', portion:0.0599192409},
      {ageIndex:7, keyName:'Facebook_MF', gender:'MF', min:'40', max:'44', portion:0.0599192409},
      {ageIndex:8, keyName:'Facebook_MF', gender:'MF', min:'45', max:'49', portion:0.0273263064},
      {ageIndex:9, keyName:'Facebook_MF', gender:'MF', min:'50', max:'59', portion:0.0372488105},
      {ageIndex:10, keyName:'Facebook_MF', gender:'MF', min:'60', max:'69', portion:0.0189609565},
    ]);
    myMap.set('Youtube_M', [
      {ageIndex:1, keyName:'Youtube_M', gender:'M', min:'7', max:'12', portion:0.0271362601},
      {ageIndex:2, keyName:'Youtube_M', gender:'M', min:'13', max:'18', portion:0.0240486035},
      {ageIndex:3, keyName:'Youtube_M', gender:'M', min:'19', max:'24', portion:0.0254228070},
      {ageIndex:4, keyName:'Youtube_M', gender:'M', min:'25', max:'29', portion:0.0160149883},
      {ageIndex:5, keyName:'Youtube_M', gender:'M', min:'30', max:'34', portion:0.0232095088},
      {ageIndex:6, keyName:'Youtube_M', gender:'M', min:'35', max:'39', portion:0.0745998768},
      {ageIndex:7, keyName:'Youtube_M', gender:'M', min:'40', max:'44', portion:0.0756303407},
      {ageIndex:8, keyName:'Youtube_M', gender:'M', min:'45', max:'49', portion:0.0591042257},
      {ageIndex:9, keyName:'Youtube_M', gender:'M', min:'50', max:'59', portion:0.0542103307},
      {ageIndex:10, keyName:'Youtube_M', gender:'M', min:'60', max:'69', portion:0.0259310431},
    ]);
    myMap.set('Youtube_F', [
      {ageIndex:1, keyName:'Youtube_F', gender:'F', min:'7', max:'12', portion:0.0142141697},
      {ageIndex:2, keyName:'Youtube_F', gender:'F', min:'13', max:'18', portion:0.0676697345},
      {ageIndex:3, keyName:'Youtube_F', gender:'F', min:'19', max:'24', portion:0.0455580993},
      {ageIndex:4, keyName:'Youtube_F', gender:'F', min:'25', max:'29', portion:0.0585316433},
      {ageIndex:5, keyName:'Youtube_F', gender:'F', min:'30', max:'34', portion:0.1004653970},
      {ageIndex:6, keyName:'Youtube_F', gender:'F', min:'35', max:'39', portion:0.0499610055},
      {ageIndex:7, keyName:'Youtube_F', gender:'F', min:'40', max:'44', portion:0.0500520744},
      {ageIndex:8, keyName:'Youtube_F', gender:'F', min:'45', max:'49', portion:0.0762627429},
      {ageIndex:9, keyName:'Youtube_F', gender:'F', min:'50', max:'59', portion:0.0903348326},
      {ageIndex:10, keyName:'Youtube_F', gender:'F', min:'60', max:'69', portion:0.0416423164},
    ]);
    myMap.set('Youtube_MF', [
      {ageIndex:1, keyName:'Youtube_MF', gender:'MF', min:'7', max:'12', portion:0.0413504298},
      {ageIndex:2, keyName:'Youtube_MF', gender:'MF', min:'13', max:'18', portion:0.0917183380},
      {ageIndex:3, keyName:'Youtube_MF', gender:'MF', min:'19', max:'24', portion:0.0709809063},
      {ageIndex:4, keyName:'Youtube_MF', gender:'MF', min:'25', max:'29', portion:0.0745466316},
      {ageIndex:5, keyName:'Youtube_MF', gender:'MF', min:'30', max:'34', portion:0.1236749058},
      {ageIndex:6, keyName:'Youtube_MF', gender:'MF', min:'35', max:'39', portion:0.1245608823},
      {ageIndex:7, keyName:'Youtube_MF', gender:'MF', min:'40', max:'44', portion:0.1256824150},
      {ageIndex:8, keyName:'Youtube_MF', gender:'MF', min:'45', max:'49', portion:0.1353669686},
      {ageIndex:9, keyName:'Youtube_MF', gender:'MF', min:'50', max:'59', portion:0.1445451633},
      {ageIndex:10, keyName:'Youtube_MF', gender:'MF', min:'60', max:'69', portion:0.0675733595},
    ]);
    myMap.set('SMR_M', [
      {ageIndex:1, keyName:'SMR_M', gender:'M', min:'7', max:'12', portion:0.0007449231},
      {ageIndex:2, keyName:'SMR_M', gender:'M', min:'13', max:'18', portion:0.0048310583},
      {ageIndex:3, keyName:'SMR_M', gender:'M', min:'19', max:'24', portion:0.0256099035},
      {ageIndex:4, keyName:'SMR_M', gender:'M', min:'25', max:'29', portion:0.0339244792},
      {ageIndex:5, keyName:'SMR_M', gender:'M', min:'30', max:'34', portion:0.0654994406},
      {ageIndex:6, keyName:'SMR_M', gender:'M', min:'35', max:'39', portion:0.0451413521},
      {ageIndex:7, keyName:'SMR_M', gender:'M', min:'40', max:'44', portion:0.0594433017},
      {ageIndex:8, keyName:'SMR_M', gender:'M', min:'45', max:'49', portion:0.0536438804},
      {ageIndex:9, keyName:'SMR_M', gender:'M', min:'50', max:'59', portion:0.0767127666},
      {ageIndex:10, keyName:'SMR_M', gender:'M', min:'60', max:'69', portion:0.0318364281},
    ]);
    myMap.set('SMR_F', [
      {ageIndex:1, keyName:'SMR_F', gender:'F', min:'7', max:'12', portion:0.0043155848},
      {ageIndex:2, keyName:'SMR_F', gender:'F', min:'13', max:'18', portion:0.0094289587},
      {ageIndex:3, keyName:'SMR_F', gender:'F', min:'19', max:'24', portion:0.0489085873},
      {ageIndex:4, keyName:'SMR_F', gender:'F', min:'25', max:'29', portion:0.0261631566},
      {ageIndex:5, keyName:'SMR_F', gender:'F', min:'30', max:'34', portion:0.0842358692},
      {ageIndex:6, keyName:'SMR_F', gender:'F', min:'35', max:'39', portion:0.1170615914},
      {ageIndex:7, keyName:'SMR_F', gender:'F', min:'40', max:'44', portion:0.1054532867},
      {ageIndex:8, keyName:'SMR_F', gender:'F', min:'45', max:'49', portion:0.0739339198},
      {ageIndex:9, keyName:'SMR_F', gender:'F', min:'50', max:'59', portion:0.0838379458},
      {ageIndex:10, keyName:'SMR_F', gender:'F', min:'60', max:'69', portion:0.0492735611},
    ]);
    myMap.set('SMR_MF', [
      {ageIndex:1, keyName:'SMR_MF', gender:'MF', min:'7', max:'12', portion:0.0050605079},
      {ageIndex:2, keyName:'SMR_MF', gender:'MF', min:'13', max:'18', portion:0.0142600170},
      {ageIndex:3, keyName:'SMR_MF', gender:'MF', min:'19', max:'24', portion:0.0745184907},
      {ageIndex:4, keyName:'SMR_MF', gender:'MF', min:'25', max:'29', portion:0.0600876358},
      {ageIndex:5, keyName:'SMR_MF', gender:'MF', min:'30', max:'34', portion:0.1497353098},
      {ageIndex:6, keyName:'SMR_MF', gender:'MF', min:'35', max:'39', portion:0.1622029435},
      {ageIndex:7, keyName:'SMR_MF', gender:'MF', min:'40', max:'44', portion:0.1648965884},
      {ageIndex:8, keyName:'SMR_MF', gender:'MF', min:'45', max:'49', portion:0.1275778002},
      {ageIndex:9, keyName:'SMR_MF', gender:'MF', min:'50', max:'59', portion:0.1605507124},
      {ageIndex:10, keyName:'SMR_MF', gender:'MF', min:'60', max:'69', portion:0.0811099892},
    ]);
    myMap.set('Digital_M', [
      {ageIndex:1, keyName:'Digital_M', gender:'M', min:'7', max:'12', portion:0.0104489344},
      {ageIndex:2, keyName:'Digital_M', gender:'M', min:'13', max:'18', portion:0.0397837771},
      {ageIndex:3, keyName:'Digital_M', gender:'M', min:'19', max:'24', portion:0.0349839487},
      {ageIndex:4, keyName:'Digital_M', gender:'M', min:'25', max:'29', portion:0.0555067668},
      {ageIndex:5, keyName:'Digital_M', gender:'M', min:'30', max:'34', portion:0.0737312578},
      {ageIndex:6, keyName:'Digital_M', gender:'M', min:'35', max:'39', portion:0.0357236443},
      {ageIndex:7, keyName:'Digital_M', gender:'M', min:'40', max:'44', portion:0.0437991661},
      {ageIndex:8, keyName:'Digital_M', gender:'M', min:'45', max:'49', portion:0.0649750312},
      {ageIndex:9, keyName:'Digital_M', gender:'M', min:'50', max:'59', portion:0.0807304995},
      {ageIndex:10, keyName:'Digital_M', gender:'M', min:'60', max:'69', portion:0.0478003095},
    ]);
    myMap.set('Digital_F', [
      {ageIndex:1, keyName:'Digital_F', gender:'F', min:'7', max:'12', portion:0.0257901772},
      {ageIndex:2, keyName:'Digital_F', gender:'F', min:'13', max:'18', portion:0.0302851173},
      {ageIndex:3, keyName:'Digital_F', gender:'F', min:'19', max:'24', portion:0.0379230547},
      {ageIndex:4, keyName:'Digital_F', gender:'F', min:'25', max:'29', portion:0.0187524256},
      {ageIndex:5, keyName:'Digital_F', gender:'F', min:'30', max:'34', portion:0.0355067377},
      {ageIndex:6, keyName:'Digital_F', gender:'F', min:'35', max:'39', portion:0.0941061640},
      {ageIndex:7, keyName:'Digital_F', gender:'F', min:'40', max:'44', portion:0.0886780365},
      {ageIndex:8, keyName:'Digital_F', gender:'F', min:'45', max:'49', portion:0.0743912858},
      {ageIndex:9, keyName:'Digital_F', gender:'F', min:'50', max:'59', portion:0.0697911226},
      {ageIndex:10, keyName:'Digital_F', gender:'F', min:'60', max:'69', portion:0.0372925433},
    ]);
    myMap.set('Digital_MF', [
      {ageIndex:1, keyName:'Digital_MF', gender:'MF', min:'7', max:'12', portion:0.0362391116},
      {ageIndex:2, keyName:'Digital_MF', gender:'MF', min:'13', max:'18', portion:0.0700688943},
      {ageIndex:3, keyName:'Digital_MF', gender:'MF', min:'19', max:'24', portion:0.0729070035},
      {ageIndex:4, keyName:'Digital_MF', gender:'MF', min:'25', max:'29', portion:0.0742591924},
      {ageIndex:5, keyName:'Digital_MF', gender:'MF', min:'30', max:'34', portion:0.1092379955},
      {ageIndex:6, keyName:'Digital_MF', gender:'MF', min:'35', max:'39', portion:0.1298298083},
      {ageIndex:7, keyName:'Digital_MF', gender:'MF', min:'40', max:'44', portion:0.1324772026},
      {ageIndex:8, keyName:'Digital_MF', gender:'MF', min:'45', max:'49', portion:0.1393663170},
      {ageIndex:9, keyName:'Digital_MF', gender:'MF', min:'50', max:'59', portion:0.1505216221},
      {ageIndex:10, keyName:'Digital_MF', gender:'MF', min:'60', max:'69', portion:0.0850928528},
    ]);
    myMap.set('PC_M', [
      {ageIndex:1, keyName:'PC_M', gender:'M', min:'7', max:'12', portion:0.0140351726},
      {ageIndex:2, keyName:'PC_M', gender:'M', min:'13', max:'18', portion:0.0260049262},
      {ageIndex:3, keyName:'PC_M', gender:'M', min:'19', max:'24', portion:0.0118374180},
      {ageIndex:4, keyName:'PC_M', gender:'M', min:'25', max:'29', portion:0.0354659803},
      {ageIndex:5, keyName:'PC_M', gender:'M', min:'30', max:'34', portion:0.0574718941},
      {ageIndex:6, keyName:'PC_M', gender:'M', min:'35', max:'39', portion:0.0536370241},
      {ageIndex:7, keyName:'PC_M', gender:'M', min:'40', max:'44', portion:0.0500659352},
      {ageIndex:8, keyName:'PC_M', gender:'M', min:'45', max:'49', portion:0.0333223614},
      {ageIndex:9, keyName:'PC_M', gender:'M', min:'50', max:'59', portion:0.1203798619},
      {ageIndex:10, keyName:'PC_M', gender:'M', min:'60', max:'69', portion:0.1200508784},
    ]);
    myMap.set('PC_F', [
      {ageIndex:1, keyName:'PC_F', gender:'F', min:'7', max:'12', portion:0.0235324535},
      {ageIndex:2, keyName:'PC_F', gender:'F', min:'13', max:'18', portion:0.0210489974},
      {ageIndex:3, keyName:'PC_F', gender:'F', min:'19', max:'24', portion:0.0134231524},
      {ageIndex:4, keyName:'PC_F', gender:'F', min:'25', max:'29', portion:0.0284381531},
      {ageIndex:5, keyName:'PC_F', gender:'F', min:'30', max:'34', portion:0.0444354699},
      {ageIndex:6, keyName:'PC_F', gender:'F', min:'35', max:'39', portion:0.1048279969},
      {ageIndex:7, keyName:'PC_F', gender:'F', min:'40', max:'44', portion:0.0612423085},
      {ageIndex:8, keyName:'PC_F', gender:'F', min:'45', max:'49', portion:0.0426439117},
      {ageIndex:9, keyName:'PC_F', gender:'F', min:'50', max:'59', portion:0.0586374109},
      {ageIndex:10, keyName:'PC_F', gender:'F', min:'60', max:'69', portion:0.0794986933},
    ]);
    myMap.set('PC_MF', [
      {ageIndex:1, keyName:'PC_MF', gender:'MF', min:'7', max:'12', portion:0.0375676261},
      {ageIndex:2, keyName:'PC_MF', gender:'MF', min:'13', max:'18', portion:0.0470539237},
      {ageIndex:3, keyName:'PC_MF', gender:'MF', min:'19', max:'24', portion:0.0252605705},
      {ageIndex:4, keyName:'PC_MF', gender:'MF', min:'25', max:'29', portion:0.0639041334},
      {ageIndex:5, keyName:'PC_MF', gender:'MF', min:'30', max:'34', portion:0.1019073641},
      {ageIndex:6, keyName:'PC_MF', gender:'MF', min:'35', max:'39', portion:0.1584650210},
      {ageIndex:7, keyName:'PC_MF', gender:'MF', min:'40', max:'44', portion:0.1113082436},
      {ageIndex:8, keyName:'PC_MF', gender:'MF', min:'45', max:'49', portion:0.0759662731},
      {ageIndex:9, keyName:'PC_MF', gender:'MF', min:'50', max:'59', portion:0.1790172728},
      {ageIndex:10, keyName:'PC_MF', gender:'MF', min:'60', max:'69', portion:0.1995495717},
    ]);
    myMap.set('Mobile_M', [
      {ageIndex:1, keyName:'Mobile_M', gender:'M', min:'7', max:'12', portion:0.0099896299},
      {ageIndex:2, keyName:'Mobile_M', gender:'M', min:'13', max:'18', portion:0.0421670177},
      {ageIndex:3, keyName:'Mobile_M', gender:'M', min:'19', max:'24', portion:0.0407205029},
      {ageIndex:4, keyName:'Mobile_M', gender:'M', min:'25', max:'29', portion:0.0552044689},
      {ageIndex:5, keyName:'Mobile_M', gender:'M', min:'30', max:'34', portion:0.0712356284},
      {ageIndex:6, keyName:'Mobile_M', gender:'M', min:'35', max:'39', portion:0.0291392484},
      {ageIndex:7, keyName:'Mobile_M', gender:'M', min:'40', max:'44', portion:0.0451007275},
      {ageIndex:8, keyName:'Mobile_M', gender:'M', min:'45', max:'49', portion:0.0676113297},
      {ageIndex:9, keyName:'Mobile_M', gender:'M', min:'50', max:'59', portion:0.0761373833},
      {ageIndex:10, keyName:'Mobile_M', gender:'M', min:'60', max:'69', portion:0.0417542088},
    ]);
    myMap.set('Mobile_F', [
      {ageIndex:1, keyName:'Mobile_F', gender:'F', min:'7', max:'12', portion:0.0255286130},
      {ageIndex:2, keyName:'Mobile_F', gender:'F', min:'13', max:'18', portion:0.0311494529},
      {ageIndex:3, keyName:'Mobile_F', gender:'F', min:'19', max:'24', portion:0.0438223822},
      {ageIndex:4, keyName:'Mobile_F', gender:'F', min:'25', max:'29', portion:0.0160173732},
      {ageIndex:5, keyName:'Mobile_F', gender:'F', min:'30', max:'34', portion:0.0327123524},
      {ageIndex:6, keyName:'Mobile_F', gender:'F', min:'35', max:'39', portion:0.0855867712},
      {ageIndex:7, keyName:'Mobile_F', gender:'F', min:'40', max:'44', portion:0.0953823788},
      {ageIndex:8, keyName:'Mobile_F', gender:'F', min:'45', max:'49', portion:0.0817173356},
      {ageIndex:9, keyName:'Mobile_F', gender:'F', min:'50', max:'59', portion:0.0766520270},
      {ageIndex:10, keyName:'Mobile_F', gender:'F', min:'60', max:'69', portion:0.0323711684},
    ]);
    myMap.set('Mobile_MF', [
      {ageIndex:1, keyName:'Mobile_MF', gender:'MF', min:'7', max:'12', portion:0.0355182428},
      {ageIndex:2, keyName:'Mobile_MF', gender:'MF', min:'13', max:'18', portion:0.0733164706},
      {ageIndex:3, keyName:'Mobile_MF', gender:'MF', min:'19', max:'24', portion:0.0845428851},
      {ageIndex:4, keyName:'Mobile_MF', gender:'MF', min:'25', max:'29', portion:0.0712218421},
      {ageIndex:5, keyName:'Mobile_MF', gender:'MF', min:'30', max:'34', portion:0.1039479807},
      {ageIndex:6, keyName:'Mobile_MF', gender:'MF', min:'35', max:'39', portion:0.1147260196},
      {ageIndex:7, keyName:'Mobile_MF', gender:'MF', min:'40', max:'44', portion:0.1404831063},
      {ageIndex:8, keyName:'Mobile_MF', gender:'MF', min:'45', max:'49', portion:0.1493286653},
      {ageIndex:9, keyName:'Mobile_MF', gender:'MF', min:'50', max:'59', portion:0.1527894103},
      {ageIndex:10, keyName:'Mobile_MF', gender:'MF', min:'60', max:'69', portion:0.0741253772},
    ]);
    myMap.set('TV_M', [
      {ageIndex:1, keyName:'TV_M', gender:'M', min:'7', max:'12', portion:0.0144509227},
      {ageIndex:2, keyName:'TV_M', gender:'M', min:'13', max:'18', portion:0.0130111428},
      {ageIndex:3, keyName:'TV_M', gender:'M', min:'19', max:'24', portion:0.0205237864},
      {ageIndex:4, keyName:'TV_M', gender:'M', min:'25', max:'29', portion:0.0119503548},
      {ageIndex:5, keyName:'TV_M', gender:'M', min:'30', max:'34', portion:0.0274891633},
      {ageIndex:6, keyName:'TV_M', gender:'M', min:'35', max:'39', portion:0.0333856429},
      {ageIndex:7, keyName:'TV_M', gender:'M', min:'40', max:'44', portion:0.0515786338},
      {ageIndex:8, keyName:'TV_M', gender:'M', min:'45', max:'49', portion:0.0771259820},
      {ageIndex:9, keyName:'TV_M', gender:'M', min:'50', max:'59', portion:0.1679026027},
      {ageIndex:10, keyName:'TV_M', gender:'M', min:'60', max:'69', portion:0.1048777802},
    ]);
    myMap.set('TV_F', [
      {ageIndex:1, keyName:'TV_F', gender:'F', min:'7', max:'12', portion:0.0112436758},
      {ageIndex:2, keyName:'TV_F', gender:'F', min:'13', max:'18', portion:0.0082331176},
      {ageIndex:3, keyName:'TV_F', gender:'F', min:'19', max:'24', portion:0.0211145518},
      {ageIndex:4, keyName:'TV_F', gender:'F', min:'25', max:'29', portion:0.0137499857},
      {ageIndex:5, keyName:'TV_F', gender:'F', min:'30', max:'34', portion:0.0286355747},
      {ageIndex:6, keyName:'TV_F', gender:'F', min:'35', max:'39', portion:0.0502893797},
      {ageIndex:7, keyName:'TV_F', gender:'F', min:'40', max:'44', portion:0.0735249857},
      {ageIndex:8, keyName:'TV_F', gender:'F', min:'45', max:'49', portion:0.0729407385},
      {ageIndex:9, keyName:'TV_F', gender:'F', min:'50', max:'59', portion:0.1327101810},
      {ageIndex:10, keyName:'TV_F', gender:'F', min:'60', max:'69', portion:0.0652617978},
    ]);
    myMap.set('TV_MF', [
      {ageIndex:1, keyName:'TV_MF', gender:'MF', min:'7', max:'12', portion:0.0256945985},
      {ageIndex:2, keyName:'TV_MF', gender:'MF', min:'13', max:'18', portion:0.0212442604},
      {ageIndex:3, keyName:'TV_MF', gender:'MF', min:'19', max:'24', portion:0.0416383383},
      {ageIndex:4, keyName:'TV_MF', gender:'MF', min:'25', max:'29', portion:0.0257003405},
      {ageIndex:5, keyName:'TV_MF', gender:'MF', min:'30', max:'34', portion:0.0561247380},
      {ageIndex:6, keyName:'TV_MF', gender:'MF', min:'35', max:'39', portion:0.0836750226},
      {ageIndex:7, keyName:'TV_MF', gender:'MF', min:'40', max:'44', portion:0.1251036195},
      {ageIndex:8, keyName:'TV_MF', gender:'MF', min:'45', max:'49', portion:0.1500667205},
      {ageIndex:9, keyName:'TV_MF', gender:'MF', min:'50', max:'59', portion:0.3006127837},
      {ageIndex:10, keyName:'TV_MF', gender:'MF', min:'60', max:'69', portion:0.1701395780},
    ]);
    return myMap;
  }
}



// WEBPACK FOOTER //
// ./src/views/common/targetPortionUtils.js